import { get, post, AHPLUS_API_URL, patch } from 'api/ky';
import { type BankFields } from 'types/bankFields';

export const BASE_RESOURCE_URL = `${AHPLUS_API_URL}/api/v2/air_bundle/journeys`;

export interface AirPayoutPaymentPax {
  id: number;
  boardingPassOrBookingReference: File;
  passportOrId: File;
}

export interface AirPayoutRequest {
  countryId: string;
  bankFields: BankFields;
  airPayoutJourneys: AirPayoutPaymentPax[];
}

export interface AirPayoutUpdateRequest {
  countryId: string;
  bankFields: BankFields;
}

export const fetchAirPayoutForJourneys = async (journeyId: number) => {
  return await get(`${BASE_RESOURCE_URL}/${journeyId}/air_payout_journeys`);
};

export const triggerAirPayoutForJourneys = async (
  journeyId: number,
  payload: AirPayoutRequest,
  token = '',
) => {
  return await post(
    `${BASE_RESOURCE_URL}/${journeyId}/air_payout_journeys/payout?token=${token}`,
    payload,
  );
};

export const updateAirPayoutForJourneys = async (
  journeyId: number,
  payload: AirPayoutUpdateRequest,
  token = '',
) => {
  return await patch(
    `${BASE_RESOURCE_URL}/${journeyId}/air_payout_journeys/payout_update?token=${token}`,
    payload,
  );
};
